var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-grid',_vm._b({class:{
  'spacing-left': _vm.spacingX || _vm.spacingLeft,
  'spacing-right': _vm.spacingX || _vm.spacingRight,
  'spacing-top': _vm.spacingY || _vm.spacingTop,
  'spacing-bottom': _vm.spacingY || _vm.spacingBottom,
}},'n-grid',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }